.sidebar {
  left: unset;
  right: 0px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 31px -10px #001f9c;
}

.closed {
  display: none;
}

.launcher {
  position: relative;
  float: right;
  width: 64px;
  height: 64px;
  right: 0px;
  padding: 8px;
  border-style: solid;
  border-width: 1px;
  margin: 24px;
  margin-right: 8px;
  cursor: pointer;
}

.solo {
  position: fixed;
  top: 16px;
  right: 0;
  margin: 16px;
  background-color: #FFFFFF;
  z-index: 1;
}

.discovery-count {
  position: absolute;
  border-style: solid;
  border-width: 1px;
  border-color: #000000;
  background-color: #fcffa4;
  font-size: 10px;
  border-radius: 8px;
  padding: 2px;
  right: -8px;
  min-width: 8px;
  text-align: center;
}

.side-nav-header {
  display: flex;
  flex-direction: row-reverse;
  margin: 16px;
}

.side-nav-header > .launcher{
  margin: unset;
}

.section {
  margin: 8px;
  padding: 8px;
}

.section-header {
  font-size: 16px;
}

.buckets-bar-actions {
  position: fixed;
  bottom: 0;
}